import {StyleSheet} from 'react-native';

import {orangeLight} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  header: {
    marginTop: 30,
    marginBottom: 20,
    flexDirection: 'row',
  },
  headerText: {
    paddingLeft: 16,
    justifyContent: 'center',
  },
  progress: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 10,
  },
  progressBarContainer: {
    width: 60,
    marginRight: 10,
  },
  progressBarFill: {
    backgroundColor: orangeLight,
  },
});
